{ createContext, useState, useContext, useMemo, useCallback, useEffect } = React

EditorReadyContext = createContext(null)

EditorReadyProvider = ({ children }) ->
  [editors, setEditors] = useState new Map()

  registerEditor = useCallback (id) ->
    setEditors (prev) ->
      return prev if prev.has id
      next = new Map prev
      next.set id,
        id: id
        ready: false
        view: null
      next
  , []

  markReady = useCallback (id, view) ->
    setEditors (prev) ->
      next = new Map prev
      next.set id,
        id: id
        ready: true
        view: view
      next
  , []

  allReady = useCallback () ->
    return false if editors.size is 0
    Array.from(editors.values()).every (e) -> e.ready
  , [editors]

  value =
    registerEditor: registerEditor
    markReady: markReady
    allReady: allReady

  <EditorReadyContext.Provider value={value}>
    {children}
  </EditorReadyContext.Provider>

AllEditorsReadyChecker = ({ onReady }) ->
  context = useContext(EditorReadyContext)
  { allReady } = context || {}
  useEffect ->
    throw new Error('AllEditorsReadyChecker must be used within EditorReadyProvider') unless context
    if allReady()
      onReady?()
    undefined
  , [allReady, onReady]

  null

useEditorReady = ->
  context = useContext(EditorReadyContext)
  throw new Error('useEditorReady must be used within EditorReadyProvider') unless context
  context

module.exports = { EditorReadyProvider, useEditorReady, AllEditorsReadyChecker }
